import React from "react";
import { ETagSpecialPackageDetailType } from "@base/enums";
import CommonStyles from "..";

interface IProps {
  type: ETagSpecialPackageDetailType;
}

export default function TagSpecialPackageDetailType({ type }: IProps) {
  const getTagName = () => {
    switch (type) {
      case ETagSpecialPackageDetailType.ONLINE_SERVICE:
        return "Tư vấn trực tuyến";
      case ETagSpecialPackageDetailType.OFFLINE_SERVICE:
        return "Tại cơ sở y tế";
      case ETagSpecialPackageDetailType.HOMECARE_SERVICE:
        return "Tại nhà";
      case ETagSpecialPackageDetailType.HOMECARE_OR_OFFLINE_SERVICE:
        return "Tại nhà hoặc tại CSYT";

      default:
        return "";
    }
  };

  const getClassName = () => {
    switch (type) {
      case ETagSpecialPackageDetailType.ONLINE_SERVICE:
        return "bg-common-green500 text-common-white border-common-green500";
      case ETagSpecialPackageDetailType.OFFLINE_SERVICE:
        return "bg-common-blue100 text-common-inprogress border-common-blue500";
      case ETagSpecialPackageDetailType.HOMECARE_SERVICE:
      case ETagSpecialPackageDetailType.HOMECARE_OR_OFFLINE_SERVICE:
        return "bg-common-purple100 text-common-purple500 border-common-purple500";

      default:
        return "";
    }
  };

  return (
    <div>
      <CommonStyles.TagUI tagName={getTagName()} className={getClassName()} />
    </div>
  );
}
